import { RouterLink } from '@redux-first-router-link';
import track, { useTracking } from 'react-tracking';
import { ROUTE_ARTICLE } from '@/constants/routes';
import { useCloudflareImage } from '@/hooks/useCloudflareImage';

const ArticleFeedItem = ({
  imageUrl,
  title,
  slug,
}: {
  title: string;
  imageUrl: string | null;
  slug: string;
}) => {
  const { trackEvent } = useTracking();
  const coverImageSrc = useCloudflareImage({
    src: imageUrl,
    width: 56,
    height: 36,
    fit: 'cover',
  });

  return (
    <div className="grid gap-2.5 rounded-lg bg-surface-1 px-5 py-4">
      <div className="m-0 text-tiny font-medium text-soft [text-box-trim:trim-both]">
        Last Week
      </div>
      <div className="grid grid-cols-[auto_minmax(0,1fr)] gap-3">
        <div className="mt-0.5">
          <RouterLink
            noUnderline
            to={{ type: ROUTE_ARTICLE, payload: { slug } }}
            onClick={() => {
              trackEvent({
                modifier: 'last-week-market-article',
                action: 'click',
                slug,
              });
            }}
          >
            <img
              src={coverImageSrc}
              width={56}
              height={36}
              alt={title}
              className="rounded-md object-cover"
            />
          </RouterLink>
        </div>
        <div className="grid gap-1">
          <h2 className="m-0 text-xs font-medium">
            <RouterLink
              noUnderline
              to={{ type: ROUTE_ARTICLE, payload: { slug } }}
              onClick={() => {
                trackEvent({
                  modifier: 'market-latest-article',
                  action: 'click',
                  slug,
                });
              }}
              className="text-pretty text-[inherit]"
            >
              {title}
            </RouterLink>
          </h2>
        </div>
      </div>
    </div>
  );
};

export default track({
  type: 'track',
  subject: 'ArticleFeedItem',
})(ArticleFeedItem) as typeof ArticleFeedItem;
